import { FatoresDeRiscoType } from '../../@types/managementTypes';

export const sortMonthYear = (data: FatoresDeRiscoType[]): FatoresDeRiscoType[] => {
  const months = [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'abr',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez',
  ];

  const sortedData = data.sort((a, b) => {
    if (b.mes_ano.split('/')[1] !== a.mes_ano.split('/')[1]) {
      return Number(b.mes_ano.split('/')[1]) - Number(a.mes_ano.split('/')[1]);
    }

    return (
      months.indexOf(b.mes_ano.split('/')[0]) - months.indexOf(a.mes_ano.split('/')[0])
    );
  });

  return sortedData;
};
